// @ts-check

import AgGridReact from '~/components/Shared/AgGridExportWrapper';
import "~/assets/css/ag-grid-theme-builder.css";

/** @type {AgGridReactLib.AgGridReactProps['excelStyles']} */
const excelStyles = [
    {
        id: "cell",
        alignment: {
            horizontal: "Left",
        }
    },
    {
        id: "header",
        font: {
            bold: true,
        }
    },
    {
        id: 'stringType',
        dataType: 'String',
    },
    {
        id: 'dateFormatterNoTime',
        dataType: "DateTime",
        numberFormat: {
            format: "mmm d, yyyy"
        }
    }
]

/** @type {AgGridReactLib.AgGridReactProps} */
const infiniteRowModelProps = {
    rowModelType: "infinite",
    rowBuffer: 0,
    cacheBlockSize: 100,
    cacheOverflowSize: 2,
    maxConcurrentDatasourceRequests: 1,
    infiniteInitialRowCount: 60,
    maxBlocksInCache: 10,
}

/** @type {AgGridReactLib.AgGridReactProps} */
const clientSideRowModelProps = {
    rowModelType: "clientSide",
}

export default function ZeroDataGrid({gridRef, clientSide=false, ...props}) {
    return (
        <div className="ag-theme-custom">
            <AgGridReact
                domLayout="autoHeight"
                excelStyles={excelStyles}
                ref={gridRef}
                maintainColumnOrder={true}
                suppressMultiSort={true}
                {...(clientSide ? clientSideRowModelProps : infiniteRowModelProps)}
                {...props}
            />
        </div>
    );
}
